import { render } from "./Kindful.vue?vue&type=template&id=426219db"
import script from "./Kindful.vue?vue&type=script&lang=js"
export * from "./Kindful.vue?vue&type=script&lang=js"
script.render = render

export default script